import shared from "@lab/store/item.shared.module";
import { organisation as api } from "@/api/organisation.api";

import Bugsnag from "@/utils/bugsnag";

const state = {
	...shared.state,
	users: [],
	listings: []
};

const getters = {
	...shared.getters,
	users: (state) => state.users || [],
	listings: (state) => state.listings || []
};

const actions = {
	async fetch({ commit, dispatch }, organisationid: number) {
		commit("LOAD_START");

		const _organisation = await api.get(organisationid).catch((error) => {
			Bugsnag.notify(
				new Error(`Organisation fetch: ${error.response.data.error}`)
			);
		});

		if (_organisation) {
			dispatch(`prepare`, _organisation);
		}

		const _users = await api.users(organisationid);
		commit("SAVE_USERS_LIST", _users);

		const _listings = await api.listings(organisationid);
		commit("SAVE_LISTINGS_LIST", _listings);

		commit(`LOAD_FINISH`);
	},
	prepare({ commit }, organisation) {
		commit(`LOAD_ITEM_SUCCESS`, organisation);
	}
};

const mutations = {
	...shared.mutations,
	SAVE_USERS_LIST(state, users) {
		state.users = users;
	},
	SAVE_LISTINGS_LIST(state, listings) {
		state.listings = listings;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
